export enum SaleRequestsStatusType {
  CLOSED = 111,
}
